.bubble {
  position: relative;
  display: flex;
  justify-content: flex-start;
  /* container-type: inline-size; */
}

.content {
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
}

.role-label {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  padding: 0.04rem 0.8rem;
  font-size: 0.6rem;
  font-variation-settings: 'wdth' var(--theme-font-width-scale-sm, 100);
  line-height: 1;
  color: oklch(65% 0.15 var(--hud-primary-hue));
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  background: oklch(20% 0.1 var(--hud-primary-hue));
  border-right: 1px solid oklch(70% 0.15 var(--hud-primary-hue));
  border-left: 1px solid oklch(70% 0.15 var(--hud-primary-hue));
  translate: -50% -50%;
}
